import dayjs from "dayjs";

// Lecture de l'état de suspension de l'utilisateur connecté (stocké au login)
export const getUserConnect = () => {
  try {
    return JSON.parse(localStorage.getItem("user_connect")) || {};
  } catch {
    return {};
  }
};

const formatDate = (value) => {
  if (!value) return "";
  // Déjà au format JJ/MM/AAAA : on garde tel quel (dayjs le lirait en MM/JJ)
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value;
  const d = dayjs(value);
  return d.isValid() ? d.format("DD/MM/YYYY") : value.toString();
};

export const getSuspension = () => {
  const user = getUserConnect();
  const adherentSuspendu = user.suspension_adht === true || user.suspension_adht === "true";
  const participantSuspendu = user.suspension_part === "S";

  return {
    isSuspendu: adherentSuspendu || participantSuspendu,
    motif: (user.motif_suspension || "").toString().trim(),
    description: (user.desc_suspension || "").toString().trim(),
    dateDebut: formatDate(user.date_deb_suspension),
    // Le participant suspendu a un message spécifique (prioritaire)
    origine: participantSuspendu ? "participant" : "adherent",
  };
};

// Texte principal du message de suspension
export const getSuspensionMessage = ({ origine, motif, dateDebut }) => {
  if (origine === "adherent") return "La couverture de votre entreprise est suspendue";
  return [
    "Votre couverture a été suspendue",
    dateDebut && `depuis le ${dateDebut}`,
    motif && `pour le motif : ${motif}`,
  ]
    .filter(Boolean)
    .join(" ");
};
